export const GOALS_SEACH_PARAMS = 'open';
export const OPEN_NEW_GOAL_MODAL = 'new';
